var _style, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000048496494619393386020000017254003249991659681_);}\n\t.st1{fill:none;stroke:#D4BC87;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000024684643450634108590000004931674115044449212_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000024684643450634108590000004931674115044449212_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.9,2.1c-1.7,0-3.4,0.5-4.9,1.3C5.6,4.3,4.4,5.5,3.6,7c-1,1.5-1.3,3.1-1.5,4.8c0,1.7,0.4,3.4,1.2,4.9 l-1.2,5l5-1.2c1.3,0.7,2.8,1.1,4.3,1.2c1.5,0.1,2.9-0.2,4.4-0.9c1.3-0.6,2.6-1.5,3.5-2.6c1-1.1,1.7-2.4,2.1-3.9 c0.4-1.5,0.4-2.9,0.1-4.4c-0.4-1.5-1-2.8-1.8-4s-2.1-2.1-3.4-2.8C14.9,2.3,13.5,2.1,11.9,2.1z M7,6.6h2.7c0.1,0,0.2,0,0.4,0.1 c0.1,0.1,0.1,0.2,0.1,0.4c0,0.6,0.1,1.2,0.2,1.8c0.1,0.2,0.1,0.4,0,0.6c0,0.2-0.1,0.4-0.4,0.5l-1,0.9c0.4,0.9,1,1.6,1.6,2.2 c0.6,0.6,1.3,1.2,2.2,1.6l0.9-1c0.5-0.5,0.6-0.5,1.1-0.2c0.6,0.2,1.2,0.4,1.8,0.2c0.1,0,0.2,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4 v2.7c0,0.1,0,0.2-0.1,0.4c-0.1,0.1-0.2,0.1-0.4,0.1c-2.7-0.1-5.3-1.2-7.1-3.1c-1.7-2.1-2.9-4.5-2.9-7.2c0-0.1,0-0.2,0.1-0.4 C6.7,6.6,6.9,6.6,7,6.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.4bfecf6aa1aaecdbd9f872bd6545606e.svg";
export { ForwardRef as ReactComponent };